export default __webpack_public_path__ + "static/media/473.e93d7cc3.png";